/**
 * RequireJS plugin that loads bing
 */
var lang = (window.websiteCode === "ECO_ESP") ? "&mkt=es-us" : "&mkt=en-us";
define('bingshim', ['jquery', 'async!//www.bing.com/api/maps/mapcontrol?branch=release' + lang + '!callback'], function ($) {
   'use strict';

   var mapReadyDfd = $.Deferred(),
      mapReadyTest = function () {
         if (window.Microsoft && window.Microsoft.Maps && window.Microsoft.Maps.Location) {
            mapReadyDfd.resolve(window.Microsoft.Maps);
         } else {
            setTimeout(mapReadyTest, 100);
         }
      };

   mapReadyTest();

   return {
      load: function (name, req, onload, config) {
         mapReadyDfd.promise().done(function () {
            onload(window.Microsoft.Maps);
         });
      }
   };
});
define('bing', ['bingshim!'], function (BingMaps) {
   'use strict';
   return BingMaps;
});
